import { ApiProperty } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import {
  IsObject,
  IsString,
  IsUrl,
  MaxLength,
  MinLength,
} from 'class-validator';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { PhotoInterface } from '../interfaces/photo.interface';
import { PhotoMetaDataInterface } from '../interfaces/photo-meta-data.interface';
import {
  PHOTO_FILE_NAME_MAX_LENGTH,
  PHOTO_FILE_NAME_MIN_LENGTH,
} from '../constants/photo-validation.constants';

@Exclude()
export class PhotoDto extends CommonEntityDto implements PhotoInterface {
  @ApiProperty({
    type: 'string',
    title: 'File Name',
    description: 'Name of the photo file',
    minLength: PHOTO_FILE_NAME_MIN_LENGTH,
    maxLength: PHOTO_FILE_NAME_MAX_LENGTH,
  })
  @IsString()
  @MinLength(PHOTO_FILE_NAME_MIN_LENGTH)
  @MaxLength(PHOTO_FILE_NAME_MAX_LENGTH)
  @Expose()
  fileName!: string;

  @ApiProperty({
    type: () => Object,
    nullable: true,
    title: 'Photo Meta Data',
    description: 'Meta data from image file',
  })
  @IsObject()
  @Expose()
  metaData!: PhotoMetaDataInterface | null;

  @ApiProperty({
    nullable: true,
    title: 'The File Url',
    description: 'Full url to photo file',
  })
  @IsUrl()
  @Expose()
  fileUrl!: string | null;
}
